import { observer } from "mobx-react";
import { getVideoElementTypeFromItemType } from "../../../utils/CleversiteUtilities";
import IframeVideo from "../../utilities/VideoUtils/IframeVideo";
import Html5Video from "../../utilities/VideoUtils/Html5Video";
import moment from "moment/moment";
import { isCoursework } from "../SchoolFeedContentItem";
import { getCourseWorkIcons } from "../../blocks/SchoolBlocks/ContentItemBlock/ContentItemBlock";
import ImageComponent from "../../utilities/ImageComponent";
import PhotoCarousel from "../../utilities/PhotoCarousel";
import { isEvent, isMedia } from "./utils";
import styles from "./styles/ListItemGroup.module.scss";

export const Media = observer((props) => {
  let media: React.ReactElement | null = <></>;
  if (
    isMedia(props.itemObj) &&
    props.itemObj.json_data.videos &&
    props.itemObj.json_data.videos.videos_list
  ) {
    const type = getVideoElementTypeFromItemType(props.itemObj.type);
    media =
      type === "iframe" ? (
        <IframeVideo
          embedLink={props.itemObj.json_data.videos.videos_list[0].raw_url}
        />
      ) : (
        <Html5Video
          embedLink={props.itemObj.json_data.videos.videos_list[0].raw_url}
        />
      );
  } else if (isEvent(props.itemObj) && props.itemObj.json_data.event) {
    const start = moment(props.itemObj.json_data.event.start);
    const end = moment(props.itemObj.json_data.event.end);

    const startMonth = start.format("MMM");
    const startDay = start.format("D");

    if (props.itemObj.json_data.event.multi_day) {
      const endMonth = end.format("MMM");
      const endDay = end.format("D");

      if (startMonth === endMonth) {
        media = (
          <div className={props.style}>
            <span>{startMonth}</span>
            <span>
              {startDay} - {endDay}
            </span>
          </div>
        );
      } else {
        media = (
          <div className={props.style}>
            <span>
              {startMonth} {startDay} -
            </span>
            <span>
              {endMonth} {endDay}
            </span>
          </div>
        );
      }
    } else {
      media = (
        <div className={props.style}>
          <span>{startMonth}</span>
          <span>{startDay}</span>
        </div>
      );
    }
  } else if (isCoursework(props.itemObj)) {
    media = getCourseWorkIcons(props.itemObj);
  } else if (props.itemObj.image) {
    const imageIsSourceImage =
      props.itemObj.image === props.itemObj.source?.account_image ||
      props.itemObj.image ===
        props.itemObj.source?.account_image?.replace("_normal", "");
    media =
      props.itemObj.images.length > 1 && !imageIsSourceImage ? (
        <PhotoCarousel
          key={props.itemObj.id}
          className={styles.feedCarousel}
          images={props.itemObj.images}
          alt={props.itemObj.altText}
          onImageClick={props.onClick}
        />
      ) : (
        <ImageComponent
          data-smallwidth={imageIsSourceImage}
          src={props.itemObj.image}
          alt={props.itemObj.altText}
          onClick={props.onClick}
        />
      );
  }

  return media;
});
